module.exports = __webpack_public_path__ + "img/Form_Inactive.622b7154.svg";